import apiClient from '../apiClient';
import { UPLOAD_PREVIEW_RESTAURANT_ITEM_URL } from '../apiUrl';

const uploadMasterDataPreviewRestaurantItemApi = data => {
  return apiClient.post(UPLOAD_PREVIEW_RESTAURANT_ITEM_URL, data);
};

export default uploadMasterDataPreviewRestaurantItemApi;
